export default function locationAssign(href) {
  window.location.assign(href);
}
